export default "__VITE_ASSET__RBMtFY1N__"